import React from "react";

//Components
//--> Button
import Button from "../Button/Button";
//--> Input
import TextInput from "../Input/TextInput";
import PhoneInput from "../Input/PhoneInput";
import SelectInput from "../Input/SelectInput";

export default function Forms(props) {
  const { label, handleSubmit, TextBoxes, onSubmit } = props;
  return (
    <div className="forms">
      <h2>{label}</h2>
      <form
        noValidate
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "row", flexFlow: "row wrap" }}
      >
        {TextBoxes.map((data) => {
          return data.type === "phone" ? (
            <PhoneInput
              key={data.label}
              value={data.value}
              onChangeEvent={data.onChange}
              size="medium"
            />
          ) : data.type === "select" ? (
            <SelectInput
              key={data.label}
              style={{ margin: "10px 0px" }}
              label={data.label}
              value={data.value}
              onChangeEvent={data.onChange}
              menuItems={data.menu}
            />
          ) : (
            <TextInput
              key={data.label}
              style={{ margin: "10px 0px" }}
              value={data.value}
              onChangeEvent={data.onChange}
              label={data.label}
              multiline={data.multiline}
            />
          );
        })}
        <div className="Button">
          <Button
            label="Submit"
            variant="contained"
            styleType="primary"
            width={150}
            onClickEvent={onSubmit}
          />
        </div>
      </form>
    </div>
  );
}
